/**
 * Author:hong.rong
 * Desc:路由 (注：新增、修改路由需要同步修改lang.json)
 * Date:2022-02-17
 */

import { HOME_PATH } from '@/constants'

/**
 * 合并订单路由
 * @param routes
 * @returns
 */
export const mergeOrderRoutes = (routes: any[]) => {
  const newRoutes = [...routes]
  // newRoutes.splice(
  //   3,
  //   0,
  //   {
  //     path: '/creative/mall',
  //     translateKey: 'header:t3',
  //     name: '创意商城',
  //     exact: true,
  //     showItem: true,
  //     code: '',
  //     exclude: ['/creative/mall'],
  //   },
  //   {
  //     path: '/order',
  //     name: '我的订单',
  //     exact: true,
  //     showItem: true,
  //     code: '',
  //     exclude: ['/order', '/order/[id]'],
  //   }
  // )
  return newRoutes;
}

/**
 * showItem - 是否展示在顶部
 * code - 根据code匹配菜单权限
 * exclude - 二级路由对应的顶部一级菜单是否展示选择状态
 * guide - 是否引导页
 */

/**
 * 媒体路由
 */
export const mediaRoutes = [
  {
    path: '/media/creative',
    translateKey: 'header:t7',
    name: '媒体中心',
    exact: true,
    showItem: true,
    exclude: [
      '/media/creative',
      '/media/authorization',
      '/media/channel',
      '/media/distribution',
      '/media/creative/push ',
    ],
    guide: true,
    code: 'MEDIA',
  },
  {
    path: '/media/creative',
    name: '创意推送',
    exact: true,
    showItem: false,
    code: 'MEDIA_WORKS_PUSH',
  },
  {
    path: '/media/authorization',
    name: '授权管理',
    exact: true,
    showItem: false,
    code: 'MEDIA_AUTHORIZATION',
  },
  {
    path: '/media/channel',
    name: '频道管理',
    exact: true,
    showItem: false,
    code: 'MEDIA_CHANNEL',
  },
  {
    path: '/media/distribution',
    name: '推送记录',
    exact: true,
    showItem: false,
    code: 'MEDIA_DISTRIBUTION_RECORDS',
  },
]

/**
 * 创意灵感路由
 */
export const inspirationRoutes = [
  {
    path: '/inspiration',
    translateKey: 'header:t4',
    name: '创意灵感',
    exact: true,
    showItem: true,
    exclude: ['/inspiration/case', '/inspiration/template'],
    // exclude: ['/inspiration/template'],
    code: 'INSPIRATION',
  },
  {
    path: '/inspiration/case',
    translateKey: 'inspiration:t1',
    name: '创意案例',
    exact: true,
    showItem: false,
    code: 'INSPIRATION_CASE',
  },
  {
    path: '/inspiration/template',
    translateKey: 'inspiration:t16',
    name: '创意模板',
    exact: true,
    showItem: false,
    code: 'INSPIRATION_TEMPLATE',
  },
]

/**
 * 所有路由
 */
const routes = [
  {
    path: HOME_PATH,
    name: '首页',
    exact: true,
    showItem: true,
    code: 'INDEX',
    translateKey: 'header:t1',
  },
  {
    path: '/ai/playground',
    translateKey: 'header:t2',
    name: 'AIGC',
    exact: true,
    showItem: true,
    code: '',
    exclude: ['/ai/playground', '/ai-generator'],
  },
  ...inspirationRoutes,
  // {
  //   path: '/ai/designer',
  //   name: 'AIGC',
  //   exact: true,
  //   showItem: false,
  //   code: 'AI_DESIGNER',
  // },
  {
    path: '/ai-generator',
    name: 'AIGC_GENERATOR',
    exact: true,
    showItem: false,
    code: 'AI_GENERATOR',
  },
  {
    path: '/works',
    translateKey: 'header:t6',
    name: '内容中心',
    exact: true,
    showItem: true,
    code: 'WORKS',
  },
  ...mediaRoutes,
  {
    path: '/data/diagnosis',
    translateKey: 'header:t8',
    name: '数据中心',
    exact: true,
    showItem: true,
    exclude: ['/data/analyse', '/data/push', '/data/diagnosis'],
    guide: true,
    code: 'DATA_CENTER',
  },
  {
    path: '/data/diagnosis',
    name: '创意诊断',
    exact: true,
    showItem: false,
    code: 'DATA_DIAGNOSIS',
  },
  {
    path: '/product/manage',
    translateKey: 'header:t13',
    name: '我管理的',
    exact: true,
    showItem: false,
    code: 'PRODUCT_MANAGE',
  },
  {
    path: '/product/participate',
    name: '我参与的',
    exact: true,
    showItem: false,
    code: 'PRODUCT_PARTICIPATE',
  },
  {
    path: '/data/analyse',
    name: '创意分析',
    exact: true,
    showItem: false,
    code: 'DATA_ANALYSIS',
  },
  {
    path: '/data/push',
    name: '投放分析',
    exact: true,
    showItem: false,
    code: 'DATA_PUSH',
  },
  {
    path: '/agreement',
    name: '用户协议',
    exact: true,
    showItem: false,
  },
  {
    path: '/policy',
    name: '隐私政策',
    exact: true,
    showItem: false,
  },
  {
    path: '/cancel',
    name: '注销协议',
    exact: true,
    showItem: false,
  },
  {
    path: '/finance/record',
    translateKey: 'header:t10',
    name: '财务管理',
    exact: true,
    showItem: false,
    code: 'WALLET',
  },
  {
    path: '/corporation/info',
    translateKey: 'header:t9',
    name: '基础信息',
    exact: true,
    showItem: false,
    code: 'MANAGEMENT_INFO',
  },
  {
    path: '/corporation/department',
    name: '团队与员工',
    exact: true,
    showItem: false,
    code: 'MANAGEMENT_DEPARTMENT',
  },
  {
    path: '/corporation/roles',
    name: '角色与权限',
    exact: true,
    showItem: false,
    code: 'MANAGEMENT_ROLES',
  },
  {
    path: '/corporation',
    name: '企业管理',
    exact: true,
    showItem: false,
    code: 'MANAGERMENT',
  },
  {
    path: '/corporation/finance',
    name: '财务记录',
    exact: true,
    showItem: false,
    code: 'MANAGEMENT_WALLET',
  },
]

export default routes
